const MINUS_SIGN = "\u2212";

export const calculateDurationDiff = (oldTime: string, newTime: string): string => {
    if (!oldTime || !newTime) return "";

    const timeToMinutes = (time: string): number => {
        const [hours, minutes] = time.split(":").map(Number);
        return hours * 60 + minutes;
    };

    const oldMinutes = timeToMinutes(oldTime);
    const newMinutes = timeToMinutes(newTime);
    const diffMinutes = newMinutes - oldMinutes;

    const sign = diffMinutes >= 0 ? "+" : MINUS_SIGN;
    const absMinutes = Math.abs(diffMinutes);
    const hours = Math.floor(absMinutes / 60);
    const minutes = absMinutes % 60;

    return `${sign}${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}`;
};

export const calculatePriceDiff = (oldPrice: number, newPrice: number): number => {
    return newPrice - oldPrice;
};

export const formatPriceDiff = (diff: number): string => {
    return diff >= 0 ? `+${diff}` : `−${Math.abs(diff)}`;
};

export const toHHMM = (time: string): string => time.split(":").slice(0, 2).join(":");
